// React, Next
import { useContext } from 'react'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'

// MUI
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// Custom
import Section from '@/components/sections/Section'
import SectionHeader from '@/components/sections/SectionHeader'
import { GlobalContext } from 'context/GlobalContextProvider'

// Img
import SimpleImage from 'public/img/services/consulting.webp'

// Style
import themeColors from 'assets/theme/colors'
import breakpoints from 'assets/theme/breakpoints'
import { getFontBody } from '@/assets/theme/fonts'

export default function SimpleSection() {
  const { t } = useTranslation('index')
  const { screenDimensions } = useContext(GlobalContext)

  const stacked = screenDimensions.width < breakpoints.desktopToMobile

  const getContent = () => (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: stacked ? '1fr' : 'minmax(0, 26rem) 1fr',
        gap: stacked ? '2rem' : '3rem',
        alignItems: 'center',
        width: '100%'
      }}
    >
      <Box
        sx={{
          lineHeight: 0,
          borderRadius: '10px',
          overflow: 'hidden',
          order: stacked ? -1 : 0
        }}
      >
        <Image
          src={SimpleImage}
          alt=""
          sizes="(max-width: 990px) 100vw, 40vw"
          style={{
            width: '100%',
            height: 'auto',
            maxWidth: SimpleImage.width
          }}
        />
      </Box>

      <Box>
        <SectionHeader
          eyebrow={t('simple.eyebrow')}
          title={t('simple.title')}
        />

        {[t('simple.p1'), t('simple.p2'), t('simple.p3')].map(paragraph => (
          <Typography
            key={paragraph}
            component="p"
            fontSize={getFontBody()}
            sx={{
              lineHeight: 1.75,
              color: themeColors.gray.defaultText,
              marginBottom: '1rem',
              '&:last-of-type': { marginBottom: 0 }
            }}
          >
            {paragraph}
          </Typography>
        ))}
      </Box>
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.kroemtech.background}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
